import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { databasesApi } from '../services/api';
import { rememberLastPick } from '../services/activeDatabase';
import { useAuth } from '../context/AuthContext';
import { getLandingPath } from '../context/PreferencesContext';
import wmLogo from '../assets/logos/WM-Logo-CB-White-Header.png';

const DatabasePickerPage = () => {
  const navigate = useNavigate();
  const { accessDenied, loading: authLoading } = useAuth();
  const [databases, setDatabases] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!authLoading && accessDenied) navigate('/access-denied', { replace: true });
  }, [authLoading, accessDenied, navigate]);

  // No database selected yet — clear any stale db name off the browser tab
  useEffect(() => {
    document.title = 'DAWN';
  }, []);

  useEffect(() => {
    databasesApi.getAvailable()
      .then(res => setDatabases(res.data || []))
      .catch(() => setDatabases([]))
      .finally(() => setLoading(false));
  }, []);

  const handleSelect = (db) => {
    // URL slug comes from db.slug (the immutable Slug column), same as AuthGate. Routing
    // resolves :dbSlug against db.slug, so a display-name-derived slug matches nothing and
    // DatabaseProvider bounces straight back here. Display name is only the pre-slug fallback.
    const slug = db.slug || (db.displayName || db.name).toLowerCase();
    rememberLastPick({ slug });
    navigate(getLandingPath(slug));
  };

  useEffect(() => {
    if (!loading && databases.length === 1) handleSelect(databases[0]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, databases]);

  return (
    <div className="stui-auth-gate-backdrop">
      <div className="stui-auth-gate-card">

        {/* Branded header — same as auth gate step card */}
        <div className="stui-auth-gate-header">
          <img src={wmLogo} alt="Wunderlich-Malec" className="stui-auth-gate-logo" />
          <div className="stui-auth-gate-header-divider" />
          <div>
            <div className="stui-auth-gate-title">DAWN</div>
            <div className="stui-auth-gate-subtitle">DOCUMENTATION · ASSETS · WIRING · NETWORKING</div>
          </div>
        </div>

        <div className="stui-auth-gate-body">
          {loading ? (
            <div className="stui-list-empty">Loading...</div>
          ) : databases.length === 0 ? (
            <div className="stui-list-empty">No databases available for your account.</div>
          ) : (
            <>
              <div className="stui-auth-gate-db-header">Select a database</div>
              <div className="stui-auth-gate-db-list">
                {databases.map(db => {
                  const name = db.displayName || db.name;
                  return (
                    <button key={db.id || name} className="stui-auth-gate-db-item" onClick={() => handleSelect(db)}>
                      {db.iconUrl ? (
                        <img src={db.iconUrl} alt="" className="stui-auth-gate-db-icon" />
                      ) : (
                        <div className="stui-auth-gate-db-icon-placeholder">{name.charAt(0)}</div>
                      )}
                      <div className="stui-auth-gate-db-info">
                        <div className="stui-auth-gate-db-name">{name}</div>
                        {db.description && <div className="stui-auth-gate-db-desc">{db.description}</div>}
                      </div>
                    </button>
                  );
                })}
              </div>
            </>
          )}
        </div>

      </div>
    </div>
  );
};

export default DatabasePickerPage;
